// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__pajGU","errors":"Errors_errors__3FnZt"};